module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/march-494c0246744e00b8e245987771a7ff71.png";